"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedResponseError = void 0;
var TranslationKeys = {
    NOT_FOUND: 'management/reports/remove/errorNotFound',
    PERMISSION_DENIED: 'generic/permissionDenied',
    UNEXPECTED: 'generic/unexpectedError'
};
var getLocalizedResponseError = function (error) {
    var _a;
    var translationKey = (_a = error === null || error === void 0 ? void 0 : error.type) !== null && _a !== void 0 ? _a : 'UNEXPECTED';
    return TranslationKeys[translationKey];
};
exports.getLocalizedResponseError = getLocalizedResponseError;
